import { Controller } from "@hotwired/stimulus";

// Loads a URL into a modal iframe for read-only previews (e.g. email templates).
export default class extends Controller {
  static targets = ["iframe", "title", "spinner"];

  open(event) {
    const { url, name } = event.params;
    this.titleTarget.textContent = name || "Email Preview";

    // Reopening the same template (modal not closed in between) leaves src unchanged,
    // so no `load` event fires to hide the spinner. The content is already there —
    // just hide the spinner and skip the reload.
    if (this.iframeTarget.getAttribute("src") === url) {
      this.spinnerTarget.classList.add("d-none");
      return;
    }

    this.spinnerTarget.classList.remove("d-none");
    this.iframeTarget.src = url;
  }

  loaded() {
    if (this.iframeTarget.src) this.spinnerTarget.classList.add("d-none");
  }

  clear() {
    this.iframeTarget.removeAttribute("src");
    this.spinnerTarget.classList.remove("d-none");
  }
}
